import { pickBy, get, pick, isString, orderBy, union, isEmpty, isArray } from 'lodash';
import { getDateRangeListByFunction, getRangeBeforeCampaign, subtractDayInMoment } from '../components/DatePicker/constants';
import { ADVERTISER_SOURCE_TYPE, CONNECT_GA_STATUS, MEGAPHONE_CLASS_NAME, TRACKING_SOURCE_NAME, TRACKING_SOURCE_TYPE, VISUAL_STATUS, gbqProjectExpirationStatus } from './constant';
import { DEFAULT_TIME_ZONE_KEY } from '../components/TimeZoneSelector/constants';
import { compareDateWithDateRange } from './formatData';
import { LIST_CAMPAIGN_TOPICS, deviceCategoryId, keywordReportTableId, pagePathId, trafficChannelsId } from '../pages/ReportBuilder/constants';
import { DeleteConnectionStatus } from '../state/modules/app/advertiser';
import { WEB_DATA_TYPE } from '../state/modules/app/playout/constant'
import { defaultEmailTemplateHashmap } from '../components/InvitationForm/helpers';
import { CAMPAIGN_ANALYTICS_TOPICS, deviceCategoryAndPagePathOptions } from '../components/CampaignAnalyticsTopics';
import { locationAndChannelsOptions } from '../components/CampaignConfig';
import moment from 'moment';

export const checkEnableFeatureFlag = (enabledFlags = [], requiredFlags = []) => {
  if (requiredFlags.length === 0) {
    return true;
  }

  if (enabledFlags.length === 0) {
    return false;
  }

  for (let i = 0; i < requiredFlags.length; i++) {
    if (enabledFlags.includes(requiredFlags[i])) {
      return true;
    }
  }

  return false;
}

export const formatFloat = (value, isFloat = false, digits = 2) => {
  if (!isFloat) {
    return value;
  }

  return parseFloat(value.toFixed(digits))
}

export function getEnabledFlags(props, state) {
  const { enabledFlags: enabledFlagsProp } = props || {};
  let enabledFlags = Object.keys(
    pickBy(
      enabledFlagsProp || get(state, 'user.user.organization.kvp.features.attribute', {}),
      (value => value === 'enabled')
    ));
  if (enabledFlagsProp && enabledFlagsProp.length) {
    enabledFlags = enabledFlagsProp;
  }
  return enabledFlags;
}



export function getEnabledFlagsInConfigApp(props, state) {
  const { enabledFlags: enabledFlagsProp } = props || {};
  const featureFlagConfig = get(state, 'featureFlagConfig.data', {})
  let enabledFlags = featureFlagConfig.filter(item => item.value === "true").map(item => item.configKey);
  if (enabledFlagsProp && enabledFlagsProp.length) {
    enabledFlags = enabledFlagsProp;
  }
  return enabledFlags;
}

export function getValueByKeyInAppConfig(appConfig, key) {
  if (!appConfig) {
    return "";
  }

  const value = appConfig.find((item) => item.configKey === key).value || "";
  return value;
}

export function getChannelHashmapByCondition(hash, conditions) {
  const {
    isHideChannelFields,
    isAvgCostDisabled,
    isNewAdUsersEnabled,
    isKeywordTable,
  } = conditions;
  const filterHash = pickBy(hash, (_value, key) => {
    switch (key) {
      case 'avgAdCost': {
        return !isAvgCostDisabled && !isHideChannelFields && !isKeywordTable;
      }
      case 'newAdUsers': {
        return isNewAdUsersEnabled;
      }
      default: return true;
    }
  });
  return filterHash;
};

export function getChannelDataHashmapByCondition(hash, conditions) {
  const {
    isHideChannelFields,
    isAvgCostDisabled,
    isNewAdUsersEnabled,
    isNewAdUsersSelected
  } = conditions;
  const filterHash = pickBy(hash, (value, key) => {
    switch (key) {
      case 'avgAdCost': {
        return !isAvgCostDisabled && !isHideChannelFields;
      }
      case 'newAdUsers': {
        return isNewAdUsersEnabled && isNewAdUsersSelected;
      }
      case 'newAdUsersOfAds': {
        return isNewAdUsersEnabled && isNewAdUsersSelected && !isHideChannelFields;
      }
      case 'adVisits': {
        return !isNewAdUsersSelected;
      }
      case 'visitOfAds': {
        return !isNewAdUsersSelected && !isHideChannelFields;
      }
      default: return true;
    }
  });
  return filterHash;
};

export function getChannelCsvDataHashmapByCondition(hash, conditions) {
  const {
    isHideChannelFields,
    isAvgCostDisabled,
    isNewAdUsersEnabled,
    isNewAdUsersSelected
  } = conditions;
  const filterHash = pickBy(hash, (value, key) => {
    if (key === 'avgAdCost') {
      return !isAvgCostDisabled && !isHideChannelFields;
    } else if (key === 'newAdUsers' || key === 'newAdUsersRate') {
      return isNewAdUsersEnabled && isNewAdUsersSelected;
    } else if (key === 'newAdUsersOfAds'){
      return isNewAdUsersEnabled && isNewAdUsersSelected && !isHideChannelFields;
    } else if (key === 'adVisits' || key === 'adVisitsRate'){
      return !isNewAdUsersSelected;
    } else if (key === 'visitOfAds') {
      return !isNewAdUsersSelected && !isHideChannelFields;
    } else {
      return true;
    }
  })
  return filterHash;
};

export function getKeywordDataHashmapByConditions(hash, conditions) {
  const { isNewAdUsersSelected } = conditions;
  const filterKeys = ['keywordValue', isNewAdUsersSelected ? 'newAdUsers' : 'adVisits'];
  const filterHash = pick(hash, filterKeys);
  return filterHash;
}
export function sortDataForTable(sortKey, sortType, tableData) {
  return orderBy(
    tableData,
    obj => {
      if (isString(obj[sortKey])){
        return obj[sortKey].toLowerCase();
      }
      return obj[sortKey];
    },
    sortType
  );
}

export function getAdvertiserConnectInfo(gaTrackingInfo = {}) {
  const accountName = get(gaTrackingInfo, 'google_analytics_name');
  const accountId = get(gaTrackingInfo, 'google_analytics_id');
  const uaPropertyName = get(gaTrackingInfo, 'google_analytics_property_name');
  const uaPropertyId = get(gaTrackingInfo, 'google_analytics_property_id');
  const uaViewName = get(gaTrackingInfo, 'google_analytics_view_name');
  const uaViewId = get(gaTrackingInfo, 'google_analytics_view_id');
  const ga4PropertyId = get(gaTrackingInfo, 'ga4_property_id');
  const ga4PropertyName = get(gaTrackingInfo, 'ga4_property_name');

  let propertyName = '', propertyId = '', viewName = '', viewId = '';
  if (ga4PropertyId) {
    propertyName = ga4PropertyName;
    propertyId = ga4PropertyId;
  } else {
    propertyId = uaPropertyId;
    propertyName = uaPropertyName;
    viewId = uaViewId;
    viewName = uaViewName;
  }
  return {
    accountName,
    accountId,
    propertyName,
    propertyId,
    viewName,
    viewId
  };
}

export function getGA4PropertyId(advertiser) {
  const ga4PropertyId = get(advertiser, 'ga4_property_id');
  return ga4PropertyId;
}

export function getUAPropertyId(advertiser) {
  const uaSourceId = TRACKING_SOURCE_TYPE.GOOGLE_ANALYTICS;
  const uaPropertyIdFromTracking = get(advertiser, [
    'advertiser_tracking_info',
    uaSourceId,
    'google_analytics_property_id'
  ]);
  const uaPropertyId = get(advertiser, 'google_analytics_property_id');
  return uaPropertyId || uaPropertyIdFromTracking;
}

export function getAdvertiserTrackingInfo(advertiser) {
  const sourceName = get(advertiser, 'trackingDataSourceName', '');
  const advTrackingInfo = get(advertiser, "advertiser_tracking_info", {});

  if (sourceName === TRACKING_SOURCE_NAME.ADOBE) {
    const adobeTrackingInfo = get(advTrackingInfo, TRACKING_SOURCE_TYPE.ADOBE, {});
    return adobeTrackingInfo;
  }

  const uaSourceId = TRACKING_SOURCE_TYPE.GOOGLE_ANALYTICS;
  const uaTrackingInfo = get(advTrackingInfo, uaSourceId, {});
  const ga4SourceId = TRACKING_SOURCE_TYPE.GA4;
  const ga4TrackingInfo = get(advTrackingInfo, ga4SourceId, {});
  const hasGa4Connection = !!getGA4PropertyId(advertiser);
  let gaTrackingInfo = hasGa4Connection ? ga4TrackingInfo : uaTrackingInfo;
  return gaTrackingInfo;
}

export function checkAdvertiserConnectedGA4Only(advertiser) {
  const isGA4Advertiser = !!getGA4PropertyId(advertiser);
  const isUAAdvertiser = getUAPropertyId(advertiser);
  const isGA4AdvertiserOnly = isGA4Advertiser && !isUAAdvertiser;
  /*
    This is too separate logic of GA4 Phase 2 and 1.5
    TODO:Remove false when apply GA4 Phase 1.5
  */
  return false && isGA4AdvertiserOnly;
}

export function campaignSourceIncludesOnly(campaign, item) {
  const campaignSources = get(campaign, 'campaignSources') || [];
  return campaignSources.join('') === item;
}

export function shouldShowSunsetDisclaimer(campaign) {
  return false; // UA is no longer supported
}

export function shouldShowNewAdUserSunsetDisclaimer(campaign, isNewAdUserSelected) {
  return isNewAdUserSelected && isInGAConnection(campaign);
}

export function masterDatePickerChange(selected, value, campaign) {
  const newCampaign = {
    ...campaign,
    masterCalendar: {
        selected,
        value: value || -1
    },
    firstCalendar: { selected, value: -1 },
    secondCalendar: { selected: getRangeBeforeCampaign(selected), value: -1 },
    selectedAdSources: undefined
  }
  return {
    newCampaign
  }
}

export function secondDatePickerChange(secondRange, campaign) {
    return {
        ...campaign,
        secondCalendar: {
            selected: secondRange,
            value: -1
        }
    }
}

export function shouldShowTileByDateCompare({
  advertiser,
  campaign,
  customReportDateRange,
}) {
  const campaignSources = get(campaign, 'campaignSources') || [];
  if (!campaignSources.includes(TRACKING_SOURCE_NAME.GA4)) {
    return true;
  }

  const cutOverDate = get(advertiser, 'google_analytics_cutover_date');
  // Advertiser connected to GA4 only
  if (!cutOverDate) {
    return false;
  }

  // Advertiser connected to both UA and GA4, check campaign filtered date range
  const {
    comparedDateRange,
    timezoneKey
  } = calculateComparedDateRange({
    campaign, customReportDateRange
  });
  const {
    isAfterOrEqual
  } = compareDateWithDateRange({
    dateRange: comparedDateRange,
    comparedDate: cutOverDate,
    timezoneKey,
  });
  return isAfterOrEqual;
}

export function shouldShowTabDisclaimer(connectionInfo) {
  return !shouldShowTileByDateCompare(connectionInfo);
}

export function shouldShowLocationAndChannels(connectionInfo) {
  return shouldShowTileByDateCompare(connectionInfo);
} 

export function isInGA4Connection({
  advertiser,
  campaign,
  customReportDateRange,
}) {
  const campaignSources = get(campaign, 'campaignSources') || [];
  if (!campaignSources.includes(TRACKING_SOURCE_NAME.GA4)) {
    return false;
  }
  
  const cutOverDate = get(advertiser, 'google_analytics_cutover_date');
  // Advertiser connected to GA4 only
  if (!cutOverDate) {
    return true;
  }

  // Advertiser connected to both UA and GA4, check campaign filtered date range
  const {
    comparedDateRange,
    timezoneKey
  } = calculateComparedDateRange({
    campaign, customReportDateRange
  });
  const {
    isInGA4DateRange
  } = compareDateWithDateRange({
    dateRange: comparedDateRange,
    comparedDate: cutOverDate,
    timezoneKey,
  });
  return isInGA4DateRange;
}

export function shouldShowNewUserSessions(connectionInfo) {
  return isInGA4Connection(connectionInfo);
}

const calculateComparedDateRange = ({campaign, customReportDateRange}) => {
  const filteredDateRange = get(campaign, 'masterCalendar', {});
  const timezoneKey = get(
    campaign,
    'timezoneSetting.timezoneKey',
    DEFAULT_TIME_ZONE_KEY
  );
  const customRangeValue = filteredDateRange.value;
  const rangeByCustomValue =
    getDateRangeListByFunction(subtractDayInMoment) || {};
  let comparedDateRange =
    (customRangeValue === -1
      ? get(filteredDateRange, 'selected')
      : rangeByCustomValue[customRangeValue]) || {};
  if (
    customReportDateRange &&
    customReportDateRange.start &&
    customReportDateRange.end
  ) {
    comparedDateRange = {
      ...customReportDateRange
    };
  }
  return {
    comparedDateRange,
    timezoneKey
  }
}

export function getAdvertiserState(state) {
  const payload = get(state, 'location.payload', {});
  const { advertiserId } = payload;
  const advertiser = get(state, ['advertiser', 'byId', advertiserId], {});
  return advertiser;
}

export function getCampaignState(state) {
  const payload = get(state, 'location.payload', {});
  const { campaignId } = payload;
  const campaign = get(state, ['campaign', 'byId', campaignId], {});
  return campaign;
}

export function filterChartsAndTablesByConditions(
  initialChartsAndTables = [],
  isDeviceCategoryAndPagePathEnabled,
  showKeywordTable
) {
  if (isDeviceCategoryAndPagePathEnabled && showKeywordTable) {
    return initialChartsAndTables;
  } else {
    let filteredChartsAndTables = initialChartsAndTables;
    if (!isDeviceCategoryAndPagePathEnabled) {
      filteredChartsAndTables = initialChartsAndTables.filter(item => {
        if (item.id != deviceCategoryId && item.id != pagePathId) {
          return item;
        }
      });
    }
    if (!showKeywordTable) {
      const channelsItemIndex = filteredChartsAndTables.findIndex(
        item => item.id === trafficChannelsId
      );
      if (channelsItemIndex !== -1) {
        const channelsItemData = filteredChartsAndTables[channelsItemIndex];
        filteredChartsAndTables[channelsItemIndex] = {
          ...channelsItemData,
          children: channelsItemData.children.filter(
            item => item.id !== keywordReportTableId
          )
        };
      }
    }
    return filteredChartsAndTables;
  }
}

export function isAdvertiserDisconnected(advertiser) {
  if (!advertiser) {
    return false;
  }
  const {
    connect_status_ga: gaConnectStatus,
    google_analytics_property_id: uaPropertyId,
    ga4_property_id: ga4PropertyId
  } = advertiser;
  const isAdvertiserDisconnected = (gaConnectStatus === CONNECT_GA_STATUS.PENDING || gaConnectStatus === CONNECT_GA_STATUS.DISCONNECTED)
                                    && (ga4PropertyId || uaPropertyId);
  return !!isAdvertiserDisconnected;
}

export function checkUaOnlyAdvertiser(advertiser) {
  const {
    google_analytics_view_id,
    ga4_property_id
  } = advertiser;
  const isUaOnlyAdvertiser = google_analytics_view_id && !ga4_property_id;
  return isUaOnlyAdvertiser;
}

export function isDormantUaAdvertiser(advertiser) {
  if (!advertiser) {
    return true;
  }
  const {
    google_analytics_view_id,
    ga4_property_id,
    connect_status_ga,
    campaigns
  } = advertiser;
  const isUaOnlyConnectedAdvertiser = google_analytics_view_id && !ga4_property_id && connect_status_ga === CONNECT_GA_STATUS.CONNECTED;
  if (!isUaOnlyConnectedAdvertiser) {
    return false;
  }
  if (!campaigns || campaigns.length === 0) {
    return true;
  }
  const formatedCampaignEndDates = campaigns.map(campaign => {
    const {
      timezone,
      end_date
    } = campaign;
    const timezoneKey = get(timezone, 'timezoneKey', DEFAULT_TIME_ZONE_KEY);
    const endDateUtc = moment(end_date).tz(timezoneKey).utc().format();
    return endDateUtc;
  });
  const sortedEndDates = formatedCampaignEndDates.sort();
  const lastEndDateUtc = sortedEndDates[sortedEndDates.length - 1];
  const currentDateUtc = moment(new Date()).utc();
  const isDormantUaAdvertiser = moment(lastEndDateUtc).isBefore(currentDateUtc);
  return isDormantUaAdvertiser;
}

export function loadDisabledCampaignLabel(isUnderDisconnectedAdvertiser, advertiserDisconnectedLabel, isDormantUaAdvertiser, dormantUaAdvertiserLabel) {
  const defaultLabel = '';
    if (isUnderDisconnectedAdvertiser) {
      return advertiserDisconnectedLabel;
    }
    if (isDormantUaAdvertiser) {
      return dormantUaAdvertiserLabel;
    }
    return defaultLabel;
}

export function isAdvertiserConnectedToUAAndGA4(advertiser) {
  const {
    google_analytics_property_id: uaPropertyId,
    ga4_property_id: ga4PropertyId
  } = advertiser;

  if (!advertiser) {
    return false;
  }
  
  const isAdvertiserConnectedToUAAndGA4 = uaPropertyId && ga4PropertyId
  return !!isAdvertiserConnectedToUAAndGA4;
}

export function updateStateWhenGa4ConnectionRemoved({ selectedAdvertiserToResendGA4Invite, advertisers, isOpenDeleteGa4ConnectionModal, emailTemplate }) {
  const { advertiser_id: selectedAdvertiserId, inviteRecipient } = selectedAdvertiserToResendGA4Invite || {};
  const defaultEmailInfo =
    defaultEmailTemplateHashmap(TRACKING_SOURCE_NAME.GA4, emailTemplate) ||
    {};

  if (!selectedAdvertiserId || !isOpenDeleteGa4ConnectionModal) {
    return null;
  }
  
  const advertiser = advertisers.find(
    (advertiser) => advertiser.advertiser_id === selectedAdvertiserId
  );
  
  if (!advertiser) {
    return null;
  }
  
  if (advertiser.ga4ConnectionRemovalStatus === DeleteConnectionStatus.SUCCESS) {
    const initialEmails = inviteRecipient ? [inviteRecipient] : [];
    const newEmailInfo = {
      emails: initialEmails,
      template: defaultEmailInfo || {},
      emailValue: ''
    }
    return {
      isSelectedAdvertiserLoading: advertiser.loading,
      isOpenDeleteGa4ConnectionModal: false,
      inviteModalId: selectedAdvertiserId,
      emailInfo: newEmailInfo,
    };
  }
  if (advertiser.ga4ConnectionRemovalStatus === DeleteConnectionStatus.FAILED) {
    return {
      isSelectedAdvertiserLoading: advertiser.loading,
      isOpenDeleteGa4ConnectionModal: false,
      selectedAdvertiserToResendGA4Invite: {},
    }
  }
  
  return {
    isSelectedAdvertiserLoading: advertiser.loading,
  }
}

export function getMeasurementId(advertiser) {
  const measurementId = get(
    advertiser,
    [
    'advertiser_tracking_info',
    TRACKING_SOURCE_TYPE.GA4,
    'websiteData',
    0,
    'webStreamData',
    'measurementId'
    ],
    ''
  );
  return measurementId;
}

export function isWebUploadAdvertiser(advertiser) {
  return get(advertiser, 'tracking_data_type') === WEB_DATA_TYPE;
}

export function isWebUploadConnection(campaign) {
  return campaignSourceIncludesOnly(campaign, TRACKING_SOURCE_NAME.WEB_UPLOAD)
}

export const mergeData = ({ baseResult, newData, keys }) => {

  let resultData = {...baseResult};
  keys.map(key => {
    if( key === 'station_name') {
      resultData[key] = union(baseResult[key], newData[key]);
    } else {
      resultData[key] = (baseResult[key] || 0) + (newData[key] || 0);
    } 
  })
  return resultData;
}

export const overrideSnapShotConfig = ({reportBuilderSnapshot, snapshot, isShowAlphaMediaDashboardUI}) => {
  const compareSnapshot = reportBuilderSnapshot.filter(({ id: id1 }) => !snapshot.some(({ id: id2 }) => id2 === id1));
  let newSnapshotConfig = [...snapshot];
  compareSnapshot.forEach(item => {
    const index = reportBuilderSnapshot.findIndex(snapshot => snapshot.id === item.id);
    item.showInReport = true;
    if (item.customOptions) {
      const newCustomOptions = item.customOptions.map((option) => ({
        ...option,
        showInReport: true,
      }));
      item.customOptions = [...newCustomOptions];
    }
    newSnapshotConfig = [
        ...newSnapshotConfig.slice(0, index),
        item,
        ...newSnapshotConfig.slice(index),
    ]
  });

  if (isShowAlphaMediaDashboardUI) {
    //Move lift item to end of snapshots
    const liftItems = newSnapshotConfig.filter(item => item.id === "liftSnapshot" || item.id === "dualLiftSnapshot");
    const newArr = newSnapshotConfig.filter(item => item.id !== "liftSnapshot" && item.id !== "dualLiftSnapshot");
    newSnapshotConfig = newArr.concat(liftItems);
    //Override color and name alpha media ui
    newSnapshotConfig = newSnapshotConfig.map(item => {
      item.backgroundColor = reportBuilderSnapshot.find(snapshot => snapshot.id === item.id).backgroundColor;
      item.name = reportBuilderSnapshot.find(snapshot => snapshot.id === item.id).name;
      return item;
    });
  };
  return newSnapshotConfig;
}

export const isGBQAdvertiser = (advertiser) => {
  if (!advertiser) {
    return false;
  }
  
  const {
    gbq_project_id: gbqProjectId,
    ga4_property_id: ga4PropertyId
  } = advertiser;
  
  const gbqAdvertiser = ga4PropertyId && gbqProjectId
  return !!gbqAdvertiser;
}

export const isPixelAdvertiser = (advertiser) => {
  if (!advertiser) {
    return false;
  }
  const { advertiserPixelIDs = [] } = advertiser;
  
  return !!advertiserPixelIDs.length
}

export const getAdvertiserSourceType = (advertiser) => {
  if (!advertiser) {
    return null;
  }
  const uaPropertyId = getUAPropertyId(advertiser);
  const ga4PropertyId = getGA4PropertyId(advertiser);
  
  //TODO: Check to see if we can use CONNECTION_SOURCE from client/src/helpers/constant.js
  if (isWebUploadAdvertiser(advertiser)) {
    return ADVERTISER_SOURCE_TYPE.WEB_UPLOAD;
  } else if (isPixelAdvertiser(advertiser)) {
    return ADVERTISER_SOURCE_TYPE.PIXEL;
  } else if (isGBQAdvertiser(advertiser)) {
    return ADVERTISER_SOURCE_TYPE.GBQ;
  } else if (!uaPropertyId && ga4PropertyId) {
    return ADVERTISER_SOURCE_TYPE.GA4;
  } else if (uaPropertyId && ga4PropertyId) {
    return ADVERTISER_SOURCE_TYPE.CUSTOM
  } else {
    return null;
  }
}

export const isInGAConnection = (campaign) => {
  const campaignSources = get(campaign, 'campaignSources') || [];
  return campaignSources.includes(TRACKING_SOURCE_NAME.GA4);
}

export const shouldShowGa4Message = (campaign) => {
  return isInGAConnection(campaign);
}

export function extractSourceNames(trackingSources) {
  if (isEmpty(trackingSources)) {
      return [];
  }
  const extractedSourceNames = trackingSources.reduce((acc, item) => {
      const dataCollections = get(item, 'data_collections', []);
      const sourceNames = dataCollections.map(entry => entry.source_name);
      acc = acc.concat(sourceNames);
      return acc;
  }, []);
  return extractedSourceNames;
};

export function getTrackingDataSourceName(trackingSources) {
  const sourceNames = extractSourceNames(trackingSources);
  // Default as GA4
  let trackingDataSourceName = TRACKING_SOURCE_NAME.GA4;
  // TODO: we choose the first sourceName until supporting multiple connections, we need to update this logic
  if (sourceNames.length > 0) {
    trackingDataSourceName = sourceNames[0];
  }

  return trackingDataSourceName;
}

export function sortCampaignAnalyticsTopics(data) {
  const campaignAnalyticsTopicsRes = data.find(item => item.setting_name === CAMPAIGN_ANALYTICS_TOPICS);
  const campaignAnalyticsTopics = get(campaignAnalyticsTopicsRes, 'setting_value', []);
  let newSortData = [];
  LIST_CAMPAIGN_TOPICS.map(item => {
    const topic = campaignAnalyticsTopics.find(obj => obj.key === item);
    newSortData.push(topic);
  });
  return newSortData;
}

export function filterDashboardTabWithCondition({campaign, advertiser, campaignAnalyticsTopicsData, isDeviceCategoryAndPagePath}) {

  let campaignDashboard = [...campaignAnalyticsTopicsData];
  const isShowLocationAndChannels = shouldShowLocationAndChannels({ advertiser, campaign });
  const trackingDataSourceName = get(advertiser, 'trackingDataSourceName');

  const isPixelAdv = trackingDataSourceName === TRACKING_SOURCE_NAME.PIXEL;

  if(!isDeviceCategoryAndPagePath) {
    campaignDashboard = campaignDashboard.filter(obj => !deviceCategoryAndPagePathOptions.includes(obj.key))
  };

  if(!isShowLocationAndChannels) {
    campaignDashboard = campaignDashboard.filter(obj => !locationAndChannelsOptions.includes(obj.key))
  };

  if (isPixelAdv) {
    campaignDashboard = campaignDashboard.filter(obj => obj.key !== trafficChannelsId);
  }

  return campaignDashboard;
}

export const isAdvertiserWithNoConnection = (advertiserInfo) => {
  if (!advertiserInfo || isEmpty(advertiserInfo)) {
    return false;
  }
  const {
    google_analytics_property_id,
    ga4_property_id,
  } = advertiserInfo;
  return !(google_analytics_property_id || ga4_property_id);
}

export const shouldShowDualNewUserTile = (campaign) => {
  return (
    campaignSourceIncludesOnly(campaign, TRACKING_SOURCE_NAME.WEB_UPLOAD) ||
    campaignSourceIncludesOnly(campaign, TRACKING_SOURCE_NAME.PIXEL) ||
    campaignSourceIncludesOnly(campaign, TRACKING_SOURCE_NAME.BIG_QUERY)
  );
};

export const getMegaphoneColor = (advertiser) => {
  const {
    visualConnectStatus,
  } = advertiser;

  return MEGAPHONE_CLASS_NAME[visualConnectStatus];
  
};
export const checkSmallIndustryLift = ({ avgIndustryLift, advertiser }) => {
  const isHaveIndustry = get(advertiser, 'industry.industryId')
  return Boolean(avgIndustryLift === null && isHaveIndustry)
}

export const drawDashedHorizontalLine = (slide, x, y, width, dashSize, gapSize, color, weight, type) => {
  for (let i = 0; i < width - dashSize; i += dashSize + gapSize) {
      slide.addShape(type, {
          x: x + i,
          y: y,
          w: dashSize,
          h: 0,
          line: { color: color, width: weight }
      });
  }
}

export const calculateChartMax = (value1, value2) => {
  let max = Math.max(value1, value2);
  if (max === 0) {
    return 1;
  }
  let order = 1;
  if (max >= 10) {
    order = Math.pow(10, Math.floor(Math.log10(max)));
  }
  let result = Math.floor(max/order + 1) * order;
  return result;
}

export const getConfigFromAppSetting = (appSetting, key) => {
  if (!isString(key)) {return null}
  return isArray(get(appSetting, 'data'))
    ? get(appSetting.data.find(
        setting =>
          setting && setting.setting_name === key
      ), 'setting_value')
    : null;
};

export const getGlossaryData = (
  snapshot,
  chartAndTableData,
  isShowDualLift,
  isShowDualNewUserTile,
  isPixelAdvertiser,
  isHideNewAdUsers,
  glossaryConfig
) => {
  const [snapshotConfig, graphsConfig] = glossaryConfig
    ? [
        {
          ...glossaryConfig.snapshot,
          liftSnapshot: get(glossaryConfig.snapshot, 'campaignLift')
        },
        glossaryConfig.graphs
      ]
    : [];
  if (!isArray(snapshot)) {
    return null;
  }
  if (!snapshotConfig || !graphsConfig) {
    return [[], []];
  }
  let snapshotOutput = [];
  const isShowDuaLiftGlossary =
    isShowDualLift &&
    snapshot.some(item => item.id === 'dualLiftSnapshot' && item.showInReport);
  const snapshotWithoutDual = snapshot.filter(item => {
    const itemId = get(item, 'id');
    if (itemId === 'dualLiftSnapshot') {
      return false;
    }
    if (
      isShowDualLift &&
      (itemId === 'liftSnapshot' || itemId === 'industryAverage')
    ) {
      return false;
    }
    return true;
  });
  snapshotWithoutDual.forEach(item => {
    const [snapshotId, isShowInReport] = [
      get(item, 'id'),
      get(item, 'showInReport')
    ];
    if (snapshotId && isShowInReport) {
      const snapshotItemConfig = get(snapshotConfig, snapshotId);
      if (snapshotItemConfig) {
        if (snapshotId === 'adUsersSnapshot' && isPixelAdvertiser) {
          snapshotOutput.push({
            ...get(snapshotConfig, 'adUsersSnapshotPixel'),
            id: 'adUsersSnapshot'
          });
        } else {
          snapshotOutput.push({ ...snapshotItemConfig, id: snapshotId });
        }
      }
    }
  });
  if (isShowDuaLiftGlossary) {
    const dualLift = snapshot.find(item => item.id === 'dualLiftSnapshot');
    const optionOfDualLift = get(dualLift, 'customOptions');
    if (isArray(optionOfDualLift) && optionOfDualLift.length > 0) {
      optionOfDualLift.forEach(option => {
        const [optionId, isShowInReport] = [
          get(option, 'id'),
          get(option, 'showInReport')
        ];
        const snapshotOptionConfig = get(snapshotConfig, optionId);
        if (snapshotOptionConfig && isShowInReport && optionId) {
          snapshotOutput.push({ ...snapshotOptionConfig, id: optionId });
        }
      });
    }
  }
  const showNewAdUser =
    snapshot.some(item => item.id === 'adUsersSnapshot' && item.showInReport) &&
    !isHideNewAdUsers &&
    !isShowDualNewUserTile;
  const showDualNewUserTile =
    snapshot.some(
      item => item.id === 'dualNewUsersSnapshot' && item.showInReport
    ) && isShowDualNewUserTile;
  if (!isShowDualNewUserTile) {
    snapshotOutput = snapshotOutput.filter(
      item =>
        item.id !== 'dualNewUsersSnapshot' && item.id !== 'adUsersSnapshot'
    );
  }
  // NOTE: Handle single card
  if (
    (showNewAdUser || showDualNewUserTile) &&
    !snapshotOutput.some(item => item.id === 'adUsersSnapshot')
  ) {
    const adUsersSnapshotConfig = get(snapshotConfig, 'adUsersSnapshot');
    if (adUsersSnapshotConfig) {
      if (isPixelAdvertiser) {
        snapshotOutput.push({
          ...get(snapshotConfig, 'adUsersSnapshotPixel'),
          id: 'adUsersSnapshot'
        });
      } else {
        snapshotOutput.push(adUsersSnapshotConfig);
      }
    }
  }
  snapshotOutput.sort((a, b) => a.priority - b.priority);
  // handle chart and table data
  let chartAndTableOutput = [];
  Object.keys(chartAndTableData).forEach(key => {
    if (key !== 'count') {
      const innerObject = get(chartAndTableData, key);
      const isActive = Object.values(innerObject).some(value => value === true);
      if (isActive) {
        const graphItemConfig = get(graphsConfig, key);
        graphItemConfig &&
          chartAndTableOutput.push({ ...graphItemConfig, id: key });
      }
    }
  });
  chartAndTableOutput.sort((a, b) => a.priority - b.priority);
  return [snapshotOutput, chartAndTableOutput];
};